module.exports = __webpack_public_path__ + "static/img/zltj2.fe07e82.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/image/zltj2.png
// module id = 4OPh
// module chunks = 1